import React, {useEffect, useState} from 'react';
import { Link, Navigate, useLocation, useNavigate} from 'react-router-dom';
import {useDispatch} from 'react-redux';
import axios from 'axios';
import './market.css';
import {he} from './store';
import { isMobile } from 'react-device-detect';


const Join=()=>{
    const histo = useNavigate();
    const conbiz = useLocation();
    const bonbiz = {...conbiz.state};
    
    const dispatch = useDispatch();
    const [ori, setori] = useState(false);
    const [suz, setsuz] = useState("gener");
   
    document.title = "로그인 - 돌파공모";
    useEffect(()=>{
        if(bonbiz?.kind == "biz"){
            entre();
        }else{
            gene();
        }
    },[]);

    const kana =async (e)=>{
        e.preventDefault();    
        if(suz == "gener"){
       const kona = await axios.post('/api/signin',{userId : e.target.userId.value, password : e.target.password.value}, {withCredentials : true})
       .then(dada=>{ if(dada.data == "error"){
        setori(true); document.getElementsByName('password')[0].value='';}else{
              const {trophy} = dada.data;
              const danm = trophy || [];
             
              const mabak = {...dada.data, trophy : danm};
              const paras = new URLSearchParams(conbiz.search);
              const nerl = paras.get('coin') || '/';
              const soll = paras.get('scol') || '0';
           
       dispatch(he(mabak)); histo(nerl, {replace : true});}}).catch(a=>{
        if(a.response?.data?.condition === "noinput"){
            setori(true);
        };
        if(a.response?.data?.condition === "wrongcon"){
            setori(true);
        };
        setori(true);
    document.getElementsByName('password')[0].value='';});
        }else{
            const kona = await axios.post('/api/signinbiz',{userId : e.target.userId.value, password : e.target.password.value}, {withCredentials : true})
            .then(dada=>{ if(dada.data == "error"){
             setori(true); document.getElementsByName('password')[0].value='';}else{
                   const {post} = dada.data;
                   let podom;
                   let pobit;
                   if(post == null){
                     podom = [];
                   }else{
             
                    podom = JSON.parse(dada.data.post);
                   };   
                
                  const fabak = {...dada.data, post : podom};
        
                  const paras = new URLSearchParams(conbiz.search);
                  const nerl = paras.get('coin') || '/';
               
             dispatch(he(fabak)); histo(nerl, {replace : true});}}).catch(a=>{
                if(a.response?.data?.condition === "noinput"){
                    setori(true);
                };
                if(a.response?.data?.condition === "wrongcon"){
                    setori(true);
                };
                setori(true);
         document.getElementsByName('password')[0].value='';});
        }; 
    };
    
    const gene =()=>{
        document.querySelector(".coff2").classList.remove("honzz");
        document.querySelector(".coff1").classList.add("honzz");
        setsuz("gener");
    };

    const entre=()=>{
        document.querySelector(".coff1").classList.remove("honzz");
        document.querySelector(".coff2").classList.add("honzz");
        setsuz("entrer");
    };

    return(
    <>
    <h2 className='nameku'>로그인</h2>
    <div className={isMobile ? 'mloin' : ''}>
        <div className={isMobile ? 'coffwidth' : 'coff3'}><p onClick={gene} className='coff1 honzz'>일반회원</p><p onClick={entre} className='coff2'>기업회원</p></div>
        <form className={isMobile ? 'mjofo' : 'jofo'} onSubmit={kana}>
            <span className={isMobile ? 'j222' : 'j1'}>
                <input type='text' name='userId' placeholder='아이디' required />
            </span>
            <span className={isMobile ? 'j222' : 'j1'}>
                <input type='password' name='password' placeholder='비밀번호' required />
            </span>
           {ori && <p>아이디 또는 비밀번호를 확인해주세요</p>}
           <button onSubmit={kana}> 로그인</button>
        </form>
    </div>
    <span><Link to='/find' state={suz} className='bofaz'>아이디찾기</Link></span>
    <span className='bofa'><Link to='/find' state={suz} className='bofaz'>비밀번호찾기</Link></span>
    <span className='bofa'><Link to='/gayip' className='bofaz'>회원가입</Link></span>
    </>
    );
    };
    
    const Notex = ({ user, children }) => {
        const conbiz = useLocation();
       
        if (Object.keys(user).length > 0) {
            const paras = new URLSearchParams(conbiz.search);
            const nerl = paras.get('coin') || '/';
            const sco = paras.get('scol') || '0';
            const sepa = nerl.includes('?') ? '&' : '?';
            const naon = `${nerl}${sepa}scol=${sco}`;
            return <Navigate to={naon} replace/>;
        };
        
        return children;
    };

    export {Join, Notex};